import zhCN from './json/question-answer.zh_CN.json';
import zhTW from './json/question-answer.zh_TW.json';
import en from './json/question-answer.en.json';
import ja from './json/question-answer.ja.json';
import ko from './json/question-answer.ko.json';
import ru from './json/question-answer.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
